export default __webpack_public_path__ + "static/media/icon-import-flux.649fbda8.svg";